import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Switch } from '../ui/switch';
import { clearanceAPI } from '../../lib/clearanceAPI';
import { errText } from '../../lib/lettersAPI';

export const ClearanceSettingsCard = ({ admin }) => {
  const [s, setS] = useState(null);
  useEffect(() => { clearanceAPI.settings().then(setS).catch(() => {}); }, []);
  if (!s) return null;
  const save = async () => { try { setS(await clearanceAPI.saveSettings(s)); toast.success('Clearance settings saved'); } catch (e) { toast.error(errText(e)); } };
  const day = (i) => (e) => { const f = [...s.followup_days]; f[i] = Number(e.target.value); setS({ ...s, followup_days: f }); };
  return (
    <Card data-testid="pc-settings"><CardHeader><CardTitle className="text-base">Professional clearance</CardTitle></CardHeader><CardContent className="space-y-3 text-sm">
      <label className="flex items-center justify-between gap-2">Clearance required before onboarding completion
        <Switch disabled={!admin} checked={s.required_for_onboarding} onCheckedChange={(v) => setS({ ...s, required_for_onboarding: v })} data-testid="pc-settings-required" /></label>
      <label className="flex items-center justify-between gap-2">Response requested within (business days)
        <Input disabled={!admin} type="number" className="w-20" value={s.response_days} onChange={(e) => setS({ ...s, response_days: Number(e.target.value) })} data-testid="pc-settings-days" /></label>
      <div className="flex items-center justify-between gap-2">Reminder 1 / reminder 2 / escalation (business days)
        <div className="flex gap-1">{[0, 1, 2].map((i) => <Input key={i} disabled={!admin} type="number" className="w-16" value={s.followup_days[i]} onChange={day(i)} data-testid={`pc-settings-fu-${i}`} />)}</div></div>
      <label className="flex items-center justify-between gap-2">Send follow-ups automatically (otherwise drafts for staff review)
        <Switch disabled={!admin} checked={s.auto_send_followups} onCheckedChange={(v) => setS({ ...s, auto_send_followups: v })} data-testid="pc-settings-autosend" /></label>
      {admin && <Button size="sm" onClick={save} data-testid="pc-settings-save">Save</Button>}
    </CardContent></Card>
  );
};
